

















import { Component, Prop, Vue } from 'vue-property-decorator'
import * as t from '@/types'
import steps from '@/steps'

@Component({
})
export default class ResultChart extends Vue {
  private currencySymbol = t.currencySymbol
  private steps = steps
  @Prop() private income!: number
  @Prop() private expenses!: number

  get chartMax () {
    return Math.max(this.income, this.expenses) * 1.25
  }
  get incomeString () { return `Income: ${this.currencySymbol}${this.income} per month` }
  get styleIncome () {
    const percentage = (this.income / this.chartMax) * 100
    return `height: ${percentage}%;`
  }
  get expensesString () { return `Expenditures: ${this.currencySymbol}${this.expenses} per month` }
  get styleExpenses () {
    const percentage = (this.expenses / this.chartMax) * 100
    return `height: ${percentage}%;`
  }

  get labels () {
    const max = this.chartMax
    const numLabels = 6
    const results = []
    if (max === 0) {
      return []
    }
    for (let x = 0; x < numLabels; x++) {
      const value = (max * x / numLabels).toFixed()
      results.push(`${this.currencySymbol}${value}`)
    }
    return results
  }

}
